/**
 * 5 minutes (prevents immediate refetch after SSR while keeping data fresh)
 */
export const REACT_QUERY_DEFAULT_STALE_TIME = 5 * 60 * 1000;
